import styled from 'styled-components';
import uploadBg from '~/assets/img/upload-bg.png';

import 'antd/lib/alert/style/index.css';

import 'antd/lib/table/style/index.css';
import 'antd/lib/divider/style/index.css';
import 'antd/lib/tag/style/index.css';

export const BreadcumbsContainer = styled.div`
  margin: 0 auto 10px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  p {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    color: #999999;
    span {
      text-transform: capitalize;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.01px;
      color: #74a50a;
    }
  }
  span {
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
  h3 {
    font-size: 16px;
    letter-spacing: 0.01px;
    color: #707070;
    margin-top: 5px;
  }

  div.buttons {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    button {
      width: 140px;
      height: 34px;
      margin: 0 0 0 10px;
      border-radius: 3.5px;
      background-color: #145f71;
      border: none;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      color: #fff;
      svg {
        margin-right: 5px;
      }
    }
    button.novo-registro {
      background-color: #74a50a;
    }
  }
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: -200px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const BoxAuth = styled.div`
  width: 1068px;
  min-height: 400px;
  padding: 0px 10px 10px 10px;
  margin: 0 auto;
  border: solid 0.8px #d9d9d9;
  background-color: #f7f7f7;
  div.BoxAuthContainer {
    margin: 20px auto;
    div.title {
      margin-bottom: 33px;
      h2 {
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.21;
        letter-spacing: 0.01px;
        text-align: center;
        color: #282828;
        span {
          font-weight: bold;
          color: #74a50a;
        }
      }
    }

    div.selectMonth {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 60px;

      .ant-select-selection {
        background-color: #ebeaea;
      }

      .ant-select-selection--single {
        height: 38px;
      }

      .ant-select-selection__rendered {
        line-height: 38px;
      }
    }

    /* 
    *
    *CUSTOM CSS TABLE
    *
    */

    .ant-table-thead
      > tr
      > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {
      background: #f7f7f7 !important;
    }

    .ant-table-thead
      > tr
      > th
      .ant-table-column-sorter
      .ant-table-column-sorter-inner
      .ant-table-column-sorter-up.on,
    .ant-table-thead
      > tr
      > th
      .ant-table-column-sorter
      .ant-table-column-sorter-inner
      .ant-table-column-sorter-down.on {
      color: #74a50a;
    }

    .ant-table-thead {
      border: 1px solid red;
    }

    /* 
    

    ant-table-column-has-actions ant-table-column-has-sorters ant-table-column-sort ant-table-row-cell-break-word

    
    */

    .ant-table-thead
      > tr
      > th.ant-table-column-has-actions.ant-table-column-has-sorters {
      cursor: pointer;
      background: #f7f7f7 !important;
    }

    .ant-table-thead
      > tr
      > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {
      cursor: pointer;
      background: #f7f7f7 !important;
    }

    .ant-table-thead
      > tr
      > th
      .ant-table-header-column
      .ant-table-column-sorters::before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: transparent;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
      content: '';
    }
  }
  hr {
    opacity: 0.1;
    display: block;
    margin: 60px 0;
  }

  div.ant-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    h2 {
      font-size: 20px;
      font-weight: 700;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.22;
      letter-spacing: 0.01px;
      text-align: center;
      color: #282828;
      margin-bottom: 25px;
    }
  }

  div.alertMessage {
    width: 365px;
    margin: 40px auto 0 auto;

    .ant-alert-success {
      background-color: rgba(116, 165, 10, 0.16);
      border: 1px solid #a4c951;
      .ant-alert-message {
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.1;
        letter-spacing: 0.09px;
        text-align: left;
        color: #74a50a;
      }
    }
  }

  .colInsercao {
    border-right: 1px solid #707070;
  }

  div.boxSpin {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
  }

  /*
  TABELA / GRID
*/
  .ant-table-tbody tr > td:first-child {
    white-space: nowrap;
  }
  .ant-table-thead * {
    background-color: #f7f7f7;

    span.ant-table-column-title {
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: 0.01px;
      color: #727272;
      text-align: center;
    }
  }
  .ant-table-row {
    background-color: #fff;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #e8e8e8;
    -webkit-transition: all 0.3s, border 0s;
    transition: all 0.3s, border 0s;
    margin-bottom: 7px;
  }

  /* 
    TABLE PAGINATION
  */

  .ant-pagination-item-active a {
    color: #74a50a;
  }

  .ant-pagination-item-active {
    font-weight: 500;
    background: #fff;
    border-color: #74a50a;
  }

  .ant-pagination-item-active:focus a,
  .ant-pagination-item-active:hover a {
    color: #74a50a;
  }

  .ant-pagination-item:focus a,
  .ant-pagination-item:hover a {
    color: #74a50a;
  }

  .ant-pagination-item-active:focus,
  .ant-pagination-item-active:hover {
    border-color: #74a50a;
  }
  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    color: #74a50a;
    border-color: #74a50a;
  }
`;

export const BoxUpload = styled.div`
  width: 365px;
  height: 249px;
  margin: 0 auto;
  border-radius: 8px;
  border: 2px dashed #d9e9ed;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    input {
      display: none;
    }
    label {
      background-image: url(${uploadBg});
      background-repeat: no-repeat;
      background-position: center 30px;
      display: block;
      width: 365px;
      height: 249px;
      cursor: pointer;
      position: absolute;
      color: #ffffff;
      /* background-color: red; */
      z-index: 40;
    }
    span.fileUploadText {
      font-size: 15px;
      font-weight: normal;
      line-height: 1.13;
      letter-spacing: 0.01px;
      text-align: center;
      color: #6c6c6c;
      display: block;
      margin: 5px 0;
      position: relative;
      top: 30px;
    }
  }
`;

export const BoxSendButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  position: absolute;
  top: 50px;
  z-index: 10;
  button {
    width: 150px;
    height: 34px;
    border-radius: 3.5px;
    background-color: #74a50a;
    border: none;
    color: #fff;
    font-size: 13px;
    line-height: 1.15;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }
`;

export const BoxInstructions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 30px;
  span {
    font-size: 13px;
    font-weight: normal;

    font-style: normal;
    line-height: 3;
    letter-spacing: normal;
    text-align: center;
    color: #6c6c6c;
  }
  p {
    font-size: 15px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #235f6e;
    text-decoration: underline;
  }
  a {
    color: #235f6e;
  }
`;

export const BoxFichaColeta = styled.div`
  width: 320px;
  height: 245px;
  border-radius: 8px;
  border: solid 1.5px #eaeaea;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  span {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: 0.01px;
    text-align: center;
    color: #333333;
    display: block;
    padding: 15px 0;
  }
`;

export const BoxButtonDownload = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
`;

export const BoxPagination = styled.div`
  padding: 40px 30px 30px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  ul {
    color: #235f6e;
    a {
      color: #235f6e;
      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.01px;

      svg {
        margin-bottom: -8px;
      }
    }

    a.arrowLeft {
      display: inline-block;
      margin-right: 70px;
    }
    a.arrowRight {
      display: inline-block;
      margin-left: 70px;
    }

    li.ant-pagination-item {
      border: none;
      background-color: transparent;
      width: 26px;
      min-width: 26px;
      height: 26px;
      line-height: 24px;
      a {
        font-size: 13px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.01px;
        color: #235f6e;
      }
    }
    li.ant-pagination-item-active {
      background-color: #74a50a;
      border-radius: 0;
      a {
        color: #fff;
      }
    }
  }
`;
